import axios from "./axios";
import store from "@/store";
import { buildSearchURL } from "@/utils";
import { Cookies } from "@/utils/cookies";
import firebase from "@/plugins/firebase";

export default {
  async getAuthToken() {
    const urlToken = new URLSearchParams(window.location.search).get("token");
    if (urlToken) this.setAuthToken(urlToken);

    const isFirebaseUser = store.getters["user/isFirebaseProvider"];
    const isUnknownUserWithSession =
      !store.getters["user/currentUser"] && Boolean(Cookies.get("token"));

    if (isFirebaseUser || isUnknownUserWithSession) {
      const token = await firebase.getToken();
      if (token) this.setAuthToken(token);
    }

    return Cookies.get("token");
  },
  setAuthToken(token) {
    Cookies.set("token", token);
  },
  login({ email, password, params }) {
    return axios
      .post(`/api/v3/auth/login${buildSearchURL(params)}`, { email, password }, { skipAuth: true })
      .then((response) => response);
  },

  logout() {
    Cookies.set("token", "");
  },

  generateWSPToken(data) {
    return axios.post("/api/v3/auth/wsp-token", data);
  },

  getUsersMe(params) {
    return axios.get(`/api/v3/users/me${buildSearchURL(params)}`).then((response) => response);
  },

  setAuthorizationHeader(token) {
    axios.defaults.headers.common["X-Authorization"] = `Bearer ${token}`;
  },

  sendResetPasswordCode({ email }) {
    return axios.post("/api/v3/users/sendResetCode", { email }, { skipAuth: true });
  },

  async verifyResetPasswordCode({ code }) {
    return axios
      .post("/api/v3/users/checkResetCode", { code }, { skipAuth: true })
      .then((response) => response.data);
  },

  resetPassword(data) {
    return axios.post("/api/v3/users/resetPassword", data, { skipAuth: true });
  },

  approveEmail(config) {
    return axios.post("/api/v3/users/confirm-mail", {}, config);
  },
};
